import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();

        this.setState({
            sections: [
                {
                    name: 'Horoscope',
                    mode: 'daily',
                    url: '/daily-horoscope',
                },
                {
                    name: 'Love',
                    mode: 'love',
                    url: '/daily-love-horoscope',
                },
                {
                    name: 'Tarot',
                    mode: 'tarot',
                    url: '/daily-tarot-card',
                },
                {
                    name: 'Number',
                    mode: 'number',
                    url: '/daily-number',
                },
                {
                    name: 'Hexagram',
                    mode: 'hexagram',
                    url: '/daily-hexagram',
                },
                {
                    name: 'Psychic',
                    mode: 'psychic',
                    url: '/daily-psychic-tip',
                },
            ],
        });
    }

    render({ mode }) {
        return (
            <today-module-nav>
                <nav variant={mode}>
                    {this.state.sections.map(section => {
                        const category = 'Daily Page Tabs';
                        const action = this.props.logged_in ? 'LI Impression' : 'LO Impression';
                        const label = section.name;

                        this.props.trackEvent([category, action, label]);
                        return (
                            <a
                              class={
                                  `${section.mode}${mode == section.mode ? ' active' : ''}`
                              }
                              href={section.url}
                              onClick={this.trackClick}
                              data-label={section.name}
                            >
                                {section.name}
                            </a>
                        );
                    })}
                </nav>
            </today-module-nav>
        );
    }

    trackClick = (e) => {
        const category = 'Daily Page Tabs';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        const label = e.target.dataset.label;

        this.props.trackEvent([category, action, label]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/today-module-nav.js